module.exports = __webpack_public_path__ + "static/background-1d6df896e60a90e41e4ee72316ce95af.png";